import * as Y from 'yjs';

const SCHEMA_VERSION = 1;

export function createDoc() {
  return new Y.Doc();
}

export function getNodesMap(doc) {
  return doc.getMap('nodes');
}

export function getRootOrder(doc) {
  return doc.getArray('rootOrder');
}

export function getSettings(doc) {
  return doc.getMap('settings');
}

export function getTrash(doc) {
  return doc.getMap('trash');
}

export function getMeta(doc) {
  return doc.getMap('meta');
}

export function initDefaults(doc) {
  const meta = getMeta(doc);
  if (!meta.has('schemaVersion')) {
    doc.transact(() => {
      meta.set('schemaVersion', SCHEMA_VERSION);
      meta.set('selectedId', null);
      meta.set('expanded', '[]');

      const settings = getSettings(doc);
      if (!settings.has('fontSize')) {
        settings.set('fontSize', 11);
        settings.set('letterSpacing', 0);
        settings.set('lineHeight', 1.65);
        settings.set('sort', 'manual');
        settings.set('editorH', null);
      }
    });
  }
}

// Create a node in the Y.Doc
export function createNode(doc, { id, type, name, parentId, content }) {
  const nodesMap = getNodesMap(doc);
  const now = Date.now();

  doc.transact(() => {
    const nodeMap = new Y.Map();
    nodeMap.set('id', id);
    nodeMap.set('type', type);
    nodeMap.set('name', name || '');
    nodeMap.set('parentId', parentId || null);
    nodeMap.set('createdAt', now);
    nodeMap.set('updatedAt', now);

    if (type === 'memo') {
      const text = new Y.Text();
      if (content) text.insert(0, content);
      nodeMap.set('content', text);
    } else {
      const childOrder = new Y.Array();
      nodeMap.set('childOrder', childOrder);
    }

    nodesMap.set(id, nodeMap);
  });
}

// Delete a node from the Y.Doc
export function deleteNode(doc, id) {
  const nodesMap = getNodesMap(doc);
  doc.transact(() => {
    nodesMap.delete(id);
  });
}

// Get plain object snapshot of a node
export function getNodeSnapshot(doc, id) {
  const nodesMap = getNodesMap(doc);
  const nodeMap = nodesMap.get(id);
  if (!nodeMap) return null;

  const type = nodeMap.get('type');
  const snapshot = {
    id: nodeMap.get('id'),
    type,
    name: nodeMap.get('name'),
    parentId: nodeMap.get('parentId'),
    createdAt: nodeMap.get('createdAt'),
    updatedAt: nodeMap.get('updatedAt'),
  };

  if (type === 'memo') {
    const text = nodeMap.get('content');
    snapshot.content = text ? text.toString() : '';
  } else {
    const childOrder = nodeMap.get('childOrder');
    snapshot.childOrder = childOrder ? childOrder.toArray() : [];
  }

  return snapshot;
}

// Get all nodes as plain objects
export function getAllNodes(doc) {
  const nodesMap = getNodesMap(doc);
  const result = {};
  nodesMap.forEach((nodeMap, id) => {
    result[id] = getNodeSnapshot(doc, id);
  });
  return result;
}

export { SCHEMA_VERSION };
